import { render, staticRenderFns } from "./ArchiveSummaryInfo.vue?vue&type=template&id=691cc659&scoped=true&"
import script from "./ArchiveSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./ArchiveSummaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSummaryInfo.vue?vue&type=style&index=0&id=691cc659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cc659",
  null
  
)

export default component.exports